import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import SideBar from "../components/SideBar";
import TopBar from "../components/TopBar";
import bible from "../assets/image/bible.webp";

function ResourcesArticle() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [article, setArticle] = useState(null);
  const [otherArticles, setOtherArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const { id } = useParams();
  const navigate = useNavigate();
  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);
  const TEST_BASE_URL = process.env.REACT_APP_BASE_URL;

  useEffect(() => {
    const fetchArticle = async () => {
      setLoading(true);
      setError("");
      try {
        const token = localStorage.getItem("authToken");
        const res = await fetch(`${TEST_BASE_URL}/articles/${id}`, {
          headers: {
            "Content-Type": "application/json",
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
          },
        });
        const data = await res.json();

        if (res.ok && data.status === "success") {
          let articleData = data.data?.article || data.data || {};
          articleData = {
            id: articleData.id,
            title: articleData.title || articleData.name || "Untitled",
            body:
              articleData.body ||
              articleData.content ||
              articleData.description ||
              "No content available.",
            thumbnail:
              articleData.thumbnail ||
              articleData.image ||
              articleData.photo ||
              null,
          };

          setArticle(articleData);
          fetchOtherArticles(token, articleData.id);
        } else {
          setError(data.message || "Failed to fetch article.");
        }
      } catch (err) {
        console.error("Fetch Article Error:", err);
        setError("Network error fetching article.");
      } finally {
        setLoading(false);
      }
    };

    const fetchOtherArticles = async (token, currentId) => {
      try {
        const res = await fetch(`${TEST_BASE_URL}/articles`, {
          headers: {
            "Content-Type": "application/json",
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
          },
        });
        const data = await res.json();

        if (res.ok && data.status === "success") {
          const allArticles =
            data.data?.articles || data.data || data.articles || [];
          const normalized = allArticles.map((a) => ({
            id: a.id,
            title: a.title || a.name || "Untitled",
            body: a.body || a.content || a.description || "",
            thumbnail: a.thumbnail || a.image || a.photo || null,
          }));
          const filtered = normalized.filter((art) => art.id !== currentId);
          setOtherArticles(filtered.slice(0, 2));
        }
      } catch (err) {
        console.error("Fetch Other Articles Error:", err);
      }
    };

    fetchArticle();
  }, [id]);

  const renderArticleBody = (body) => {
    if (!body) return null;
    const paragraphs = body.split("\n").filter((p) => p.trim() !== "");
    return paragraphs.map((p, idx) => (
      <p key={idx} style={{ marginBottom: "1rem" }}>
        {p}
      </p>
    ));
  };

  return (
    <section className="dashboard">
      <SideBar isOpen={sidebarOpen} />
      <div className="body-content">
        <TopBar onToggleSidebar={toggleSidebar} />
        <div className="bottom-content">
          {loading ? (
            <p>Loading article...</p>
          ) : error ? (
            <p>{error}</p>
          ) : article ? (
            <div className="row">
              <div className="col-md-8">
                <div className="eventdetails">
                  <h5>{article.title}</h5>
                  {article.thumbnail ? (
                    <img
                      src={
                        article.thumbnail.startsWith("http")
                          ? article.thumbnail
                          : `https://rccgbournemouth.org${
                              article.thumbnail.startsWith("/") ? "" : "/"
                            }${article.thumbnail}`
                      }
                      alt={article.title}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.style.display = "none";
                        e.target.nextSibling.style.display = "flex";
                      }}
                    />
                  ) : null}
                  <div className="fallbacktext" style={{ display: "none" }}>
                    <p>{article.title || "Image not available"}</p>
                  </div>

                  {renderArticleBody(article.body)}
                </div>
              </div>

              <div className="col-md-4">
                <h4 className="pt-1 explore-text">Explore Other Articles</h4>
                {otherArticles.length > 0 ? (
                  otherArticles.map((a) => (
                    <div
                      className="resource-card mt-4"
                      key={a.id}
                      onClick={() => navigate(`/resources-article/${a.id}`)}
                      style={{ cursor: "pointer" }}
                    >
                      <img
                        src={
                          a.thumbnail
                            ? a.thumbnail.startsWith("http")
                              ? a.thumbnail
                              : `https://rccgbournemouth.org${
                                  a.thumbnail.startsWith("/") ? "" : "/"
                                }${a.thumbnail}`
                            : bible
                        }
                        alt={a.title || "Article Image"}
                        className="card-img-top"
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = bible;
                        }}
                      />
                      <div className="cardbody">
                        <h5 className="card-title">{a.title}</h5>
                        <p className="card-text">
                          {a.body?.slice(0, 120) ||
                            a.sub_title ||
                            "No description available..."}
                        </p>
                        <button className="btn btn-read-more">Read More</button>
                      </div>
                    </div>
                  ))
                ) : (
                  <p>No other articles available.</p>
                )}
              </div>
            </div>
          ) : (
            <p>Article not found.</p>
          )}
        </div>
      </div>
    </section>
  );
}

export default ResourcesArticle;
